import { computed } from 'vue';
import { useQuery } from 'vue-query';
import promotionalBannersApi from 'api/promotional-banners';

export default function usePromotionalBannersQuery(queryParams = computed(() => ''), enabled = computed(() => true)) {
  const promotionalBannersQuery = useQuery(
    ['promotional-banners', queryParams],
    () => promotionalBannersApi.index(queryParams.value),
    {
      enabled: enabled.value,
    },
  );
  const promotionalBanners = computed(
    () => promotionalBannersQuery.data.value?.data.promotionalBanners as PromotionalBanner[],
  );
  const isPromotionalBannersLoading = computed(() => promotionalBannersQuery.isLoading.value);

  return {
    promotionalBannersQuery,
    promotionalBanners,
    isPromotionalBannersLoading,
  };
}
